module.exports = __webpack_public_path__ + "img/fullscreen.36c8c2f4.svg";